<div class="d-flex flex-column align-items-center">
    <div class="pb-3">
        <adapt-strategic-guidance area="purpose"></adapt-strategic-guidance>
    </div>

    @if (purpose?.content) {
        <div class="mb-4 bt-1">
            <div class="mt-2 p-3 purpose-statement">
                <label>Purpose statement</label>
                <div class="ms-2"
                     [froalaView]="purpose!.content"></div>
                @if (purpose!.notes) {
                    <div class="mt-2">
                        <label>Notes</label>
                        <div class="ms-2"
                             [froalaView]="purpose!.notes"></div>
                    </div>
                }
            </div>
        </div>
    }

    <button *adaptIfAuthorised="CompassGuidingPhilosophyEdit"
            class="btn btn-primary px-4"
            [adaptBlockingClick]="recordPurposeStatement"
            role="button">{{ !!purpose?.content ? "Update" : "Record" }} purpose statement</button>
</div>
